import myHeader from "../../components/header.vue"
import myFooter from "../../components/footer.vue"
import {getCmsList} from "../../api/service.js"

import {getGatewayNoticeDetails} from '@/apiCloud/notice'

export default{
    components:{
        myHeader,
        myFooter
    },
    data(){
        return{
            noticeContent:'',
            noticePushtime:'',
            noticeTitle:'',
            newsPic:'',
            isJx:false,
        }
    },
    created(){
        this.detailsNotice()
        this.getScreen()
        if(localStorage.getItem("isJx")=="true"){ // 是否是江西代理商访问
            this.isJx=true;
          }
    },
    mounted(){
        var publicCourse=document.getElementById("noticeContent")
        publicCourse.style.minHeight=window.innerHeight-60-74+"px"
    },
    methods:{
        //获取通知信息
        // getScreen(){
        //     let height=window.screen.availHeight
        //     // console.log("屏幕宽度",height)
        //     // console.log($("#noticeBox").height())
        //     // if ($("#noticeBox").height()<338) {
        //     //     $("#noticeBox").height(338)
        //     //     console.log(111111)
        //     //     console.log($("#noticeBox").height())
        //     // }
           
        // },
        detailsNotice(){
            let url="notice/getGatewayNoticeDetails"
            let data={
                noticeId:this.$route.query.noticeId 
            }
            getGatewayNoticeDetails(data).then(res=>{
                console.log("通知详情",res)
                if(res.code==200){
                    let item=res.data
                    this.noticeContent=item.noticeContent
                    this.noticePushtime=item.noticePushtimeStr
                    this.noticeTitle=item.noticeTitle
                    this.noticeContent=item.noticeContent
                }else{
                    this.$message.error(res.message)
                }
            })
        },
        //返回上一页
        goBack(){
            this.$router.go(-1)
        },
    }
}


// WEBPACK FOOTER //
// ./src/pages/noticeDetail/noticeDetail.js